const updateEmptyState = (el) => {
    // Update if "0" will be required value
    if (el.value === '0') {
        el.classList.add('empty');
    } else {
        el.classList.remove('empty');
    }
};

const initial = () => {
    document.body.addEventListener('change', (event) => {
        if (!event.target.matches('.form-select')) {
            return;
        }
        updateEmptyState(event.target);
    });

    document.querySelectorAll('.form-select').forEach(updateEmptyState);
};

export default initial;
